(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

		$('.mMenu').on('click', function(){
			if($('html, body').hasClass('navOpen')) {
				$('html, body').removeClass('navOpen');
			} else {
				$('html, body').addClass('navOpen');
			}
		});

		$('.icon-search, .searchWrp .fa').on('click', function(){
			$('html, body').toggleClass('searchOpen');
		});

    $(".menu-item.icon-search").each(function(){
      $(this).children().first().removeAttr("href");
    });

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();


	});

})(jQuery);
